export default function tld(url?: string): string {
    const tld = ((window.location.hostname.match(/^(.*?\.)(.+)$/) ?? [])[2] ?? "localhost").replaceAll(/[^a-z0-9.]/gi, "");
    return url ? url.replaceAll(/\{tld}/gi, tld) : tld;
}
